import { useEffect } from 'react';
import { track } from '../analytics';

export function RefundPage() {
  useEffect(() => {
    track({ name: 'refund_guide_opened', payload: {} });
  }, []);

  return (
    <div className="page narrow-page">
      <section className="refund-card">
        <span className="eyebrow">未激活链接退款指引</span>
        <h1>退款原因选择“与卖家协商一致”</h1>
        <p className="question-description">
          仅适用于链接尚未激活，或链接本身存在问题的情况。成功激活后不能恢复为未使用状态。
        </p>
        <div className="refund-steps">
          <ol>
            <li><strong>打开闲鱼订单</strong><span>进入对应订单并发起退款申请。</span></li>
            <li><strong>选择「与卖家协商一致」</strong><span>这是未激活链接或链接问题约定使用的退款原因。</span></li>
            <li><strong>提交并等待处理</strong><span>提交前确认选择的是正确订单。</span></li>
          </ol>
          <div className="warning-box">
            <strong>激活成功后无法取消</strong>
            <p>该订阅没有主动取消入口，成功激活的链接不能再按未使用链接申请退款。</p>
          </div>
        </div>
      </section>
    </div>
  );
}
